import "./style.scss"
import React from "react"
import Accordion from "react-bootstrap/Accordion"
import { sliderProperties } from "../../../utils"
import Carousel from "react-multi-carousel"
// import { useAccordionToggle } from "react-bootstrap/AccordionToggle"
import "react-multi-carousel/lib/styles.css"

// const Toggle = ({ children, eventKey }) => {
//   const decoratedOnClick = useAccordionToggle(eventKey, () => {
//     if (document.getElementById("ServicesShowMore").style.display === "none") {
//       document.getElementById("ServicesShowMore").style.display = "block"
//     } else {
//       document.getElementById("ServicesShowMore").style.display = "none"
//     }
//   })

//   return (
//     <button className="angle" onClick={decoratedOnClick}>
//       {children}
//     </button>
//   )
// }
const ServiceItem = ({ serviceTitle, serviceContent, bulletDirection }) => {
  if (bulletDirection === "right") {
    return (
      <div className={`service-item ${bulletDirection ? bulletDirection : ""}`}>
        <div>
          <p className="title">{serviceTitle}</p>
          <p className="text">{serviceContent}</p>
        </div>
        <div className="bullet_area">
          <div className="bullet"></div>
        </div>
      </div>
    )
  }
  return (
    <div className="service-item">
      <div className="bullet_area">
        <div className="bullet"></div>
      </div>
      <div>
        <p className="title">{serviceTitle}</p>
        <p className="text">{serviceContent}</p>
      </div>
    </div>
  )
}

const ServicesSection = ({ services, serviceSubtitle, serviceTitle }) => {
  return (
    <div className="services_section">
      <h1 className="title">
        {serviceTitle ? serviceTitle : "Services include"}
      </h1>
      <p className="subtitle">{serviceSubtitle}</p>
      <div className="desktop">
        <Accordion className="show-more-accordion">
          {services &&
            services.map((service, index) => {
              // if (index <= 2) {
              return (
                <ServiceItem
                  key={index}
                  serviceTitle={service.title}
                  serviceContent={service.content}
                  bulletDirection={index % 2 === 0 ? "left" : "right"}
                />
              )
              // } else {
              //   return (
              //     <Accordion.Collapse eventKey="0">
              //       <ServiceItem
              //         key={index}
              //         serviceTitle={service.title}
              //         serviceContent={service.content}
              //         bulletDirection={index % 2 === 0 ? "left" : "right"}
              //       />
              //     </Accordion.Collapse>
              //   )
              // }
            })}
          {/* <Toggle eventKey="0">
            <p className="show-more">
              <span id="ServicesShowMore">Show More</span>
              <span>
                <img src={ShowMoreIcon} alt="show more" />
              </span>
            </p>
          </Toggle> */}
        </Accordion>
      </div>
      <div className="mobile">
        <Carousel showDots={true} arrows={false} responsive={sliderProperties}>
          {services &&
            services.map((service, index) => {
              return (
                <ServiceItem
                  key={index}
                  serviceTitle={service.title}
                  serviceContent={service.content}
                />
              )
            })}
        </Carousel>
      </div>
    </div>
  )
}

export default ServicesSection
